<template>
	<div>
		<div ref="twoFactorVerifyBlock" class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<h1 class="text-center mt-3">Verification Code</h1>
			<p class="text-center text-muted mt-1">Enter code from your Authenticator App to Verify</p>

			<Verification :auto-submit="true" :header="false" type="two_factor" purpose="two_factor_verification" :user_id="auth .user.id" from="first-setup" @confirmation-status="verificationResponse" />

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('skip')">Skip 2FA Setup</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from "vue";
import Verification from "@/components/GenericModalAndViews/Verification.vue";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});

const emits = defineEmits(['navigationButtonClicked']);

const helper = useAppHelpers();
const auth = useAuthStore();

const twoFactorVerifyBlock = ref(null);

const moveButtonAction = async (name) => {
	if(name === 'skip') {
		try{
			helper.loaderOn(twoFactorVerifyBlock.value);
			const response = await auth.disableTwoFactor();
			helper.loaderOff(twoFactorVerifyBlock.value);
		}
		catch (error) {
			helper.loaderOff(twoFactorVerifyBlock.value);
		}
	}

}

const verificationResponse = (response) => {
	if (response[0]) {
		emits('navigationButtonClicked', 'skip');
	}
}
</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>